import translationEN from "../../locales/en/translation.json";
import translationFR from "../../locales/fr/translation.json";

// Kept free of the i18n instance: i18n.js calls this while it initialises.

const DEFAULTS_BY_LOCALE = {
  en: { ...(translationEN.term || {}) },
  fr: { ...(translationFR.term || {}) },
};

// Compound defaults that embed a customizable term. Their word order differs
// per locale, so they are rebuilt from the override when one is set.
const DERIVED_BY_LOCALE = {
  en: {
    spaceDimensions: (o) => o.space && `${o.space} Dimensions`,
    stockDimensions: (o) => o.stock && `${o.stock} Dimensions`,
  },
  fr: {
    spaceDimensions: (o) => o.space && `Dimensions ${o.space}`,
    stockDimensions: (o) => o.stock && `Dimensions ${o.stock}`,
  },
};

/**
 * The full `term.*` namespace for a locale: JSON defaults, then the customer
 * overrides, then the compound terms rebuilt from those overrides.
 */
export function buildTermNamespace(lng, overrideMap) {
  const merged = { ...DEFAULTS_BY_LOCALE[lng], ...overrideMap };
  for (const [key, derive] of Object.entries(DERIVED_BY_LOCALE[lng] || {})) {
    const value = derive(overrideMap || {});
    if (value) merged[key] = value;
  }
  return merged;
}
